import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgLockClosed = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33333 4.94507C5.33333 4.01099 5.59167 3.31242 6.01944 2.8518C6.44196 2.39685 7.08887 2.11018 8.00149 2.11018C8.91461 2.11018 9.5606 2.39628 9.98211 2.85021C10.4089 3.30985 10.6667 4.00755 10.6667 4.94213V6.39999H5.33333V4.94507ZM4.26666 6.39999V4.94507C4.26666 3.82024 4.57961 2.83471 5.23785 2.12594C5.90135 1.41151 6.8552 1.04352 8.00149 1.04352C9.14755 1.04352 10.1008 1.41048 10.7637 2.12439C11.4214 2.8326 11.7333 3.81755 11.7333 4.94213V6.39999H12.8C13.3891 6.39999 13.8667 6.87755 13.8667 7.46665V13.8667C13.8667 14.4558 13.3891 14.9333 12.8 14.9333H3.2C2.6109 14.9333 2.13333 14.4558 2.13333 13.8667V7.46665C2.13333 6.87755 2.6109 6.39999 3.2 6.39999H4.26666ZM3.2 7.46665H12.8V13.8667H3.2V7.46665Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgLockClosed)
const IconSvgLockClosed = createIcon(ForwardRef, 'SvgLockClosed')
export default IconSvgLockClosed
